import Backbone from 'backbone';
import {
  formatCost,
} from '@bingads-webui-campaign/recommendation-core';
import template from './accountVNext.pug';

export class AccountContextualAttributeView extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.accountId = targetId;
    this.budget = '';
  }


  render({ showDeliveryStatusPopup }) {
    const {
      deps,
      accountId,
      i18n,
    } = this;

    deps.jsdata.Account.findAll(
      {
        limit: 1,
        select: ['Budget/DailyBudget'],
        where: { Id: { $eq: accountId } },
      },
      {
        entitySet: deps.edmCampaign.currentCustomer.Accounts,
      }
    ).then((response) => {
      if (response.length && response.length > 0) {
        const dailyBudget = response[0].Budget.DailyBudget;

        this.budgetString = i18n.getString(
          'Account_Total_Budget',
          { dailyBudget: formatCost(dailyBudget, i18n, i18n.currency) }
        );

        this.$el.html(template({
          budgetString: this.budgetString,
        }));

        showDeliveryStatusPopup(this.el.outerHTML);
      }
    });
    return this;
  }
}
